import { GMAX_RAID_BY_SLUG } from '~/data/gmaxRaids'
import {
  getCosmeticFormsForSlug,
  type CosmeticPokemonForm,
} from '~/data/pokemonForms'

export function isGmaxFormSlug(formSlug: string): boolean {
  return formSlug.includes('-gmax') || GMAX_RAID_BY_SLUG.has(formSlug)
}

type GmaxProgressLike = Record<string, { captures?: number } | undefined>

type CollectionLike = ReadonlyArray<{
  slug: string
  cosmeticFormSlug?: string | null
}>

/** Forme Gigamax utilisable (raid capturé / crafté, ou déjà portée sur un Pokémon du compte). */
export function isGmaxFormUnlocked(
  formSlug: string,
  gmaxProgress: GmaxProgressLike,
  collection: CollectionLike,
): boolean {
  if ((gmaxProgress[formSlug]?.captures ?? 0) > 0) return true
  return collection.some((p) => p.cosmeticFormSlug === formSlug)
}

export function isPokemonFormUnlocked(
  baseSlug: string,
  formSlug: string,
  gmaxProgress: GmaxProgressLike,
  collection: CollectionLike,
): boolean {
  if (!isGmaxFormSlug(formSlug)) return true
  return isGmaxFormUnlocked(formSlug, gmaxProgress, collection)
}

/** Formes sélectionnables dans l’inventaire (les Gmax non débloquées sont exclues). */
export function getSelectableFormsForSlug(
  baseSlug: string,
  collection: CollectionLike,
  gmaxProgress: GmaxProgressLike,
): CosmeticPokemonForm[] {
  return getCosmeticFormsForSlug(baseSlug).filter((form) =>
    isPokemonFormUnlocked(baseSlug, form.slug, gmaxProgress, collection),
  )
}
